module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Ice-cream1-bcd5a108f274d1a3252dceaacec43f56.svg";